import { Children } from 'react';
import I18n from 'I18n';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { ListItem } from 'foundations-components/transitional/components/List';
import ListingLibCustomizeGalleryButton from 'framework-listing-lib/internal/CustomizeGallery/components/ListingLibCustomizeGalleryButton';
import ListingLibEditColumnsButton from 'framework-listing-lib/internal/EditColumns/components/ListingLibEditColumnsButton';
import ListingLibExportButton from 'framework-listing-lib/internal/Export/components/ListingLibExportButton';
import { useHasCustomizeGallery, useHasEditColumns, useHasExport } from 'framework-listing-lib/internal/frameworkAppSettings/hooks/useFrameworkAppSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ListingLibTableActions({
  children,
  editColumnProps,
  editColumnDisabled = false,
  editColumnTooltipProps,
  sidePanelProps,
  exportModalProps
}) {
  const hasEditColumns = useHasEditColumns();
  const hasExport = useHasExport();
  const hasCustomizeGallery = useHasCustomizeGallery();
  const isEmptyChildren = Children.toArray(children).length === 0;

  // No actions
  if (!hasEditColumns && !hasExport && !hasCustomizeGallery && isEmptyChildren) {
    return null;
  }

  // Only edit columns
  if (hasEditColumns && !hasExport && isEmptyChildren && !hasCustomizeGallery) {
    return /*#__PURE__*/_jsx(ListingLibEditColumnsButton, {
      hasIcon: true,
      disabled: editColumnDisabled,
      tooltipProps: editColumnTooltipProps,
      modalProps: editColumnProps || {}
    });
  }

  // Only export
  if (!hasEditColumns && hasExport && isEmptyChildren && !hasCustomizeGallery) {
    return /*#__PURE__*/_jsx(ListingLibExportButton, {
      modalProps: exportModalProps
    });
  }

  // Only customize gallery
  if (!hasEditColumns && !hasExport && isEmptyChildren && hasCustomizeGallery) {
    return /*#__PURE__*/_jsx(ListingLibCustomizeGalleryButton, {});
  }
  return /*#__PURE__*/_jsx(Dropdown, {
    buttonSize: "extra-small",
    buttonText: I18n.text('frameworkListingLib.tableActions.actions'),
    "data-test-id": "crm-listing-table-actions",
    "data-test-name": "listing-lib-table-actions",
    buttonUse: 'tertiary-extra-light',
    children: /*#__PURE__*/_jsxs(List, {
      children: [hasExport ? /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ListingLibExportButton, {
          modalProps: exportModalProps
        })
      }) : null, hasEditColumns ? /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ListingLibEditColumnsButton, {
          hasIcon: false,
          disabled: editColumnDisabled,
          tooltipProps: editColumnTooltipProps,
          modalProps: editColumnProps || {}
        })
      }) : null, hasCustomizeGallery ? /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ListingLibCustomizeGalleryButton, {
          sidePanelProps: sidePanelProps
        })
      }) : null, children]
    })
  });
}